import { render, staticRenderFns } from "./PagesStaticTwoColWidget.vue?vue&type=template&id=6b148f12&"
import script from "./PagesStaticTwoColWidget.vue?vue&type=script&lang=js&"
export * from "./PagesStaticTwoColWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports